import React from 'react';
import Tooltip from 'rc-tooltip';

import styles from './flagCompensationStyles';

import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';
import FlagIcon from 'buyside/svgs/flag.svg';

class FlagCompensation extends React.Component {
  constructor() {
    super();
    this.state = { loading: false, flagged: false, showConfirmation: false };
    this.flagCompensation = this.flagCompensation.bind(this);
    this.renderConfirmation = this.renderConfirmation.bind(this);
  }

  flagCompensation() {
    if (this.state.loading) return;
    const { handleFlag, id } = this.props;
    this.setState({ loading: true });
    handleFlag(id).then(() => this.setState({ loading: false, flagged: true }));
  }

  renderConfirmation() {
    if (this.state.showConfirmation) {
      return (
        <div className="confirmationContainer">
          <p>Are you sure you want to flag this compensation?</p>
          <div>
            <Button
              text="Flag Compensation"
              size={BUTTON_SIZES.TINY}
              type={BUTTON_TYPES.PRIMARY}
              onClick={this.flagCompensation}
            />
            <Button
              text="Cancel"
              size={BUTTON_SIZES.TINY}
              onClick={() => this.setState({ showConfirmation: false })}
            />
          </div>
        </div>
      );
    } else {
      return 'Flag as inappropriate/inaccurate';
    }
  }

  render() {
    const { flagged } = this.state;
    if (flagged) {
      return (
        <Tooltip overlay="Compensation has been flagged" mouseEnterDelay={0.5} placement="top">
          <div className={styles.flagCompensation}>
            <FlagIcon className={styles.flagIcon + ` ${styles.flagged}`} /> COMPENSATION FLAGGED
          </div>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip
          overlay={this.renderConfirmation}
          mouseEnterDelay={0.1}
          mouseLeaveDelay={0.5}
          placement="top"
        >
          <div
            onClick={() =>
              this.setState({
                showConfirmation: true
              })
            }
            className={styles.flagCompensation}
          >
            <FlagIcon className={styles.flagIcon} /> Flag This Compensation
          </div>
        </Tooltip>
      );
    }
  }
}

export default FlagCompensation;
